export default {
      id: "Icon--list-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--list",
      toString: function () {
        return this.url;
      }
    }